import { TaskLevel } from "./Task";

export class ResourceTaskTime {
  GUID?: string;
  id?: string;
  TaskRef?: string;
  TimePlanRef?: string;
  ResourceRef?: string;
  OrigResourceRef?: string;
  resourceId?: string;
  JobNo?: string;
  JobTaskNo?: string;
  TaskTitle?: string;
  Title?: string;
  title?: string;
  end?: string;
  start?: string;
  Comment?: string;
  color?: string;
  borderColor?: string;
  editable?: boolean;
  startEditable?: boolean;
  Status?: string;
  Priority?: string;
  CalcEstimate?: number;
  Customer?: string;
  Icon?: string;
  IconColor?: string;
  constraint?: any;
  rendering?: string;
  Job_Description?: string;
  Description?: string;
  IsApproved?: boolean;
  HasBeenPlannedOn?: boolean;  
  Maintenance_Object?: string;
  App_Task_Category_Description?: string;
  Company_Reference?: string;
  TaskLevel?: TaskLevel;
}




// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/ResourceTaskTime.ts